import React from "react";
import { IntrospectionWizard } from "../../modules/assist/components";
import { demoIntrospectionFlow } from "../../modules/assist/models";

// Assist · Introspection : introspection guidée en 3 étapes.
export default function AssistIntrospection() {
  return (
    <div className="max-w-4xl mx-auto space-y-4">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Assist · Introspection</h1>
        <p className="text-sm md:text-base text-slate-600 dark:text-slate-300">
          Un espace pour réfléchir, journaliser et se poser les bonnes questions, en 3 étapes simples.
        </p>
      </header>

      <IntrospectionWizard flow={demoIntrospectionFlow} />
    </div>
  );
}
